var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.042 6.333A1.042 1.042 0 0013 5.292H6.333a1.042 1.042 0 00-1.041 1.041V13a1.041 1.041 0 001.042 1.042H13A1.042 1.042 0 0014.042 13V6.333zM10.709 3a1.041 1.041 0 00-.939-1.037l-.103-.005H3A1.042 1.042 0 001.958 3v6.667l.005.103A1.042 1.042 0 003 10.708h1.042V6.333a2.291 2.291 0 012.292-2.291h4.375V3zm1.25 1.042H13a2.291 2.291 0 012.292 2.291V13A2.291 2.291 0 0113 15.292H6.333A2.291 2.291 0 014.043 13v-1.042H3A2.291 2.291 0 01.72 9.893l-.012-.226V3A2.291 2.291 0 013 .708h6.667l.226.012A2.291 2.291 0 0111.96 3v1.042z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fd521fecb7d78e99f96747ca60356925.svg";
export { ForwardRef as ReactComponent };